/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HospiceNoAdmitReason = {
    ClinicallyInappropriate: 'clinically_inappropriate',
    InsurancePayerIssue: 'insurance_payer_issue',
    OutOfServiceArea: 'out_of_service_area',
    UnableToStaffTimely: 'unable_to_staff_timely',
    UnableToContactPatient: 'unable_to_contact_patient',
    PatientFamilyDeclined: 'patient_family_declined',
    ChoseAnotherAgency: 'chose_another_agency',
    ReadmittedHigherLevelOfCare: 'readmitted_higher_level_of_care',
    ReferralCancelledByProvider: 'referral_cancelled_by_provider',
    Deceased: 'deceased',
    Other: 'other',
} as const;
export type HospiceNoAdmitReason = typeof HospiceNoAdmitReason[keyof typeof HospiceNoAdmitReason];


export function instanceOfHospiceNoAdmitReason(value: any): boolean {
    for (const key in HospiceNoAdmitReason) {
        if (Object.prototype.hasOwnProperty.call(HospiceNoAdmitReason, key)) {
            if (HospiceNoAdmitReason[key as keyof typeof HospiceNoAdmitReason] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HospiceNoAdmitReasonFromJSON(json: any): HospiceNoAdmitReason {
    return HospiceNoAdmitReasonFromJSONTyped(json, false);
}

export function HospiceNoAdmitReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): HospiceNoAdmitReason {
    return json as HospiceNoAdmitReason;
}

export function HospiceNoAdmitReasonToJSON(value?: HospiceNoAdmitReason | null): any {
    return value as any;
}

export function HospiceNoAdmitReasonToJSONTyped(value: any, ignoreDiscriminator: boolean): HospiceNoAdmitReason {
    return value as HospiceNoAdmitReason;
}

